import React from 'react';
import {connect} from 'react-redux'
import {Form, Text} from 'react-form';
import {DropdownButton, MenuItem} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {
  HITCardBlueprintAction,
  HITCardBlueprintRowData,
  HITCardBlueprintColumnData,
  addCardToDB,
  validateEmail,
  CompanyData
} from '../utils/api';
import * as _ from "lodash"
import {getCompanies} from "../redux/actions/companies"

var protobuf = require("protobufjs");

interface CreateCardProps {
  companies: CompanyData[];
  fetchedCompanies: boolean;
  getCompanies: typeof getCompanies;
}

class CreateCard extends React.Component < CreateCardProps, {} > {
  colors = ["#8241f3", "#7a7d8e", "#5dcd11", "#fa0164"];
  valueColors = ["#373a4b", "#5dcd11", "#fa0164", "#8241f3"];
  MAX_TITLE_LENGTH = 55;
  constructor(props) {
    super(props);
    let actions = [new HITCardBlueprintAction("", _.first(this.colors))];
    let url = new URL(window.location.toString());
    let title = url.searchParams.get("title", null);
    let subtitle = url.searchParams.get("subtitle", null);
    let main_image_url = url.searchParams.get("main_image_url", null);
    let actionParam = url.searchParams.getAll("action", null);
    if (actionParam && actionParam.length > 0) {
      actions = _.map(actionParam, (title) => {
        return new HITCardBlueprintAction(title, _.first(this.colors));
      })
    };

    this.state = {
      activeParentCompany: null,
      company: null,
      companyValid: false,
      title,
      titleValid: null,
      main_image_url,
      mainImageValid: null,
      subtitle,
      productTitle: null,
      productImage: null,
      productImageValid: null,
      actions,
      actionsValid: null,
      rows: [],
      showProductFields: false,
      success: null,
      loading: null,
      enableSubmit: false
    };
    this.props.getCompanies();
  }

  componentDidMount() {
    this.validateAllRequired();
  }
  componentWillReceiveProps(nextProps) {
    const {fetchedCompanies, companies} = nextProps;
    if (fetchedCompanies && companies) {
      let url = new URL(window.location.toString());
      let companyParam = url.searchParams.get("company", null);
      if (companyParam) {
        let id = parseInt(companyParam);
        let company = _.find(companies, (o) => {
          return o.id == id
        }, null);
        if (company) {
          this.setCompany(company);
        }
      }
    }
  }
  clearState = (e) => {
    window.location.reload();
  }
  setCompany = (activeParentCompany : CompanyData, company : GeoCompany) => {
    this.setState({
      activeParentCompany,
      company,
      companyValid: true
    }, () => {
      this.checkValidation();
    });
  }
  titleChange(value) {
    this.setState({
      title: value,
      titleValid: value.length > 0 && value.length <= this.MAX_TITLE_LENGTH
    }, () => {
      this.checkValidation();
    });
  }
  imageChange(value) {
    this.doesFileExist(value, () => {
      this.setState({main_image_url: value, mainImageValid: true});
    }, () => {
      this.setState({main_image_url: "", mainImageValid: false});
    })
  }
  doesFileExist(url, success, failure) {
    var img = new Image();
    img.onload = success;
    img.onerror = failure;
    img.src = url;
  }
  subtitleChange(value) {
    this.setState({subtitle: value});
  }
  productTitleChange(value) {
    this.setState({productTitle: value});
  }
  productImageChange(value) {
    this.doesFileExist(value, () => {
      this.setState({productImage: value, productImageValid: true});
    }, () => {
      this.setState({productImage: "", productImageValid: false});
    })
  }
  actionChange = (i, value) => {
    var action = this.state.actions[i]
    action.text = value
    var actions = this.state.actions
    actions[i] = action
    let actionsValid = !(_.includes(_.map(actions, (a) => {
      return a.text.length > 0
    }), false));
    this.setState({
      actions,
      actionsValid
    }, () => {
      this.checkValidation();
    });
  }
  validateAllRequired() {
    const {actions, title, company} = this.state;
    const titleValid = title && title.length > 0 && title.length <= this.MAX_TITLE_LENGTH
    const companyValid = company != null;
    let actionsValid = !(_.includes(_.map(actions, (a) => {
      return a.text.length > 0
    }), false));
    this.setState({actionsValid, companyValid, titleValid});
  }
  colorChange = (i, color, event) => {
    var action = this.state.actions[i]
    action.color = color
    var actions = this.state.actions
    actions[i] = action
    this.setState({actions: actions});
  }
  newAction = () => {
    let action = new HITCardBlueprintAction("", _.first(this.colors))
    var actions = this.state.actions
    actions = actions.concat(action)
    this.setState({actions: actions});
  }
  newRow = () => {
    let row = new HITCardBlueprintRowData("", [])
    var rows = this.state.rows
    rows = rows.concat(row)

    this.setState({rows: rows});
  }
  newCol = (i, event) => {
    let valueColor = _.first(this.valueColors)
    let col = new HITCardBlueprintColumnData("", "", "", valueColor, null)
    let row = this.state.rows[i]
    var columns = row.columns
    columns = columns.concat(col)
    row.columns = columns
    var rows = this.state.rows
    rows[i] = row
    this.setState({rows: rows});
  }
  rowChange = (i, event) => {

    var row = this.state.rows[i]
    row.title = event.target.value
    var rows = this.state.rows
    rows[i] = row
    this.setState({rows: rows});
  }
  colTitleChange = (i, col_i, event) => {
    let row = this.state.rows[i]
    let col = row.columns[col_i]
    col.name = event.target.value
    var columns = row.columns
    columns[col_i] = col
    row.columns = columns
    var rows = this.state.rows
    rows[i] = row
    this.setState({rows: rows});
  }
  colValueChange = (i, col_i, event) => {
    let row = this.state.rows[i]
    let col = row.columns[col_i]
    col.value = event.target.value
    var columns = row.columns
    columns[col_i] = col
    row.columns = columns
    var rows = this.state.rows
    rows[i] = row
    this.setState({rows: rows});
  }
  colValueColorChange = (i, col_i, color, event) => {
    let row = this.state.rows[i]
    let col = row.columns[col_i]
    col.valueColor = color
    var columns = row.columns
    columns[col_i] = col
    row.columns = columns
    var rows = this.state.rows
    rows[i] = row
    this.setState({rows: rows});
  }
  showProductFields = () => {
    this.setState({showProductFields: true})
  }
  checkValidation() {
    let {companyValid, titleValid, actionsValid} = this.state;
    let stateHasNull = _.includes([
      companyValid, titleValid, actionsValid
    ], null);
    let enableSubmit = !stateHasNull && !(_.includes([
      companyValid, titleValid, actionsValid
    ], false));
    if (this.state.enableSubmit !== enableSubmit) {
      this.setState({enableSubmit})
    }
  }
  submitForm = (e) => {
    e.preventDefault();
    var state = this.state;
    const {company, activeParentCompany} = this.state;
    var that = this;
    let managers = _.map(activeParentCompany.user_managers, (user) => {
      return user.email;
    });
    let owners = _.map(activeParentCompany.user_owners, (user) => {
      return user.email;
    });
    let allEmails = _.cloneDeep(managers).concat(owners)
    let emails = _.uniq(allEmails)
    _.remove(emails, (email) => {
      return email.length == 0;
    });
    this.setState({loading: true});
    protobuf.load("card.proto", function(err, root) {
      if (err) 
        throw err

      var HitCard = root.lookupType("HITCards.Card")
      var companyId = company
        ? company.id
        : null;
      var rows = _.map(state.rows, (a) => {
        let columns = _.map(a.columns, (column, column_i) => {
          return {
            name: {
              text: column.name
            },
            value: {
              text: column.value,
              color: {
                hex: column.valueColor
              }
            }
          }
        });
        return {
          title: {
            text: a.title
          },
          columns: columns
        }
      })
      var actions = _.map(state.actions, (action) => {
        return {
          text: {
            text: action.text,
            color: {
              hex: action.color
            }
          },
          confirmation: {
            type: 0,
            message: {
              text: "Thank you!"
            }
          }
        }
      })
      var cardPayload = {
        geoCompanyId: companyId,
        title: {
          text: state.title,
          color: {
            hex: "#abcdef"
          }
        },
        subtitle: {
          text: state.subtitle
        },
        headerImage: {
          url: state.main_image_url
        },
        actions: actions,
        previewBanner: {
          iconUrl: {
            url: state.productImage
          },
          text: {
            text: state.productTitle
          }
        },
        rows: rows,
        notification: {
          title: "Perpetua",
          body: "Perpetua has generated a new action for you. Tap to see more."
        }
      }
      let emailCount = emails.length;
      let requestCount = 0;
      _.map(emails, (email) => {
        let newCardPayload = _.cloneDeep(cardPayload)

        newCardPayload.userEmail = email
        newCardPayload.state = 0;

        var errMsg = HitCard.verify(newCardPayload);
        if (errMsg) 
          throw Error(errMsg);
        
        var message = HitCard.create(newCardPayload);
        addCardToDB(message, (success) => {
          requestCount += 1
          if (requestCount == emailCount) {
            that.setState({success, loading: false})
          }
        })

      })

    });
  }

  render() {
    const {companies} = this.props;
    const {activeParentCompany, company, title, subtitle, main_image_url} = this.state;
    const {setCompany} = this;
    return (<div className={"container-holder create-card"}>
      <div className={"container"}>
        {
          this.state.success && <div className="mini-modal-holder">
              <div className="mini-modal">
                <div className={"content-holder"}>
                  <h1>HIT Card Created</h1>
                  <p>Card was successfully created for {this.state.company.name}</p>
                  <p className="center">
                    <Link to={'/dashboard'} className={'deep-purple-text lighten-1 link'}>
                      Go To Dashboard
                      <span className="border"></span>
                    </Link>
                    <a className={'deep-purple-text lighten-1 link'} onClick={this.clearState}>
                      Create Another Card
                      <span className="border"></span>
                    </a>
                  </p>
                  <p className="center"></p>
                </div>
              </div>
              <div className="backdropy"/>
            </div>
        }
        <h3 className="required_holder">
          Create a HIT Card
          <p className="required">*required</p>
        </h3>
        <div className="row">

          <Form render={({submitForm}) => (<form className="col s12 m5 deep-purple-text lighten-1" onSubmit={this.submitForm}>
              <div className="row">
                <div className="input-field col s12">
                  {
                    companies == null
                      ? <p className="deep-purple-text lighten-1 loading">
                          <img style={{
                              width: "20px",
                              marginRight: "10px"
                            }} alt={"img"} className="spin inline" src="/loading.png"/>
                          Loading Companies
                        </p>
                      : <div>
                          <DropdownButton id="button" className="deep-purple lighten-1" title={company
                              ? `${activeParentCompany.name} - ${company.country_code}`
                              : "Select A Company"}>
                            {
                              _.map(companies, (parentCompany : CompanyData, index) => {
                                const companyName = parentCompany.name;
                                if (!parentCompany.geo_companies) {
                                  return;
                                }
                                return <MenuItem key={index}>
                                  {companyName}
                                  <div className="geo_companies">
                                    {
                                      _.map(parentCompany.geo_companies, (c, i) => {
                                        const imageName = c.country_code.toLowerCase();
                                        const isActive = company
                                          ? company.id === c.id
                                          : false;
                                        return <a key={i} className={"flag" + (
                                            isActive
                                            ? " active"
                                            : "")} onClick={isActive
                                            ? null
                                            : () => setCompany(parentCompany, c)}>
                                          <img src={`flags/${imageName}.png`}/>
                                        </a>;
                                      })
                                    }
                                  </div>
                                </MenuItem>;
                              })
                            }
                          </DropdownButton>
                        </div>
                  }
                </div>
                <div className="input-field col s12">
                  <Text field="title" type="text" defaultValue={title} onChange={this.titleChange.bind(this)}/>
                  <div className="counter">{
                      this.state.title
                        ? (this.MAX_TITLE_LENGTH - this.state.title.length)
                        : this.MAX_TITLE_LENGTH
                    }</div>
                  <label htmlFor="title">Title *</label>
                  {
                    (this.state.titleValid !== null && !this.state.titleValid) && <p className="error">
                        {
                          this.state.title.length < 1
                            ? <span>Required</span>
                            : <span>Must Be Less than {this.MAX_TITLE_LENGTH}
                                &nbsp; Characters</span>
                        }

                      </p>
                  }
                </div>
                <div className="input-field col s12">
                  <Text field="subtitle" type="text" defaultValue={subtitle} onChange={this.subtitleChange.bind(this)}/>
                  <label htmlFor="subtitle">SubTitle</label>
                </div>
                <div className="input-field col s12">
                  <Text field="image" type="url" defaultValue={main_image_url} onChange={this.imageChange.bind(this)}/>
                  <label htmlFor="image">Image URL</label>
                  {
                    (this.state.mainImageValid !== null && !this.state.mainImageValid) && <p className="error">
                        <span>Not A Valid Image</span>
                      </p>
                  }
                </div>
                <div className="input-field col s12 actions-input">
                  <h4 className="more-holder">
                    <span>Actions *</span>
                    {
                      this.state.actions.length < 2 && <a className={"more"} onClick={this.newAction}>
                          <img alt={"img"} src={"/plus.png"}/>
                        </a>
                    }
                  </h4>
                  {
                    _.map(this.state.actions, (a, i) => {
                      return <div key={i} className="action_holder">
                        <Text field={"actions_" + i} className="action" type="text" defaultValue={a.text} onChange={this.actionChange.bind(this, i)} placeholder="Action Title"/>
                        <div className="color_picker">
                          {
                            _.map(this.colors, (hex, hex_i) => {
                              return <span key={hex_i} onClick={this.colorChange.bind(this, i, hex)} className={"box" + (
                                  a.color === hex
                                  ? " active"
                                  : "")} style={{
                                  background: hex
                                }}></span>
                            })
                          }
                        </div>
                      </div>
                    })
                  }
                </div>
                <div className="product_holder col s12">
                  {
                    !this.state.showProductFields
                      ? <a className={"link deep-purple-text lighten-1"} onClick={this.showProductFields}>Add A Product</a>
                      : <div>
                          <h4>Product</h4>
                          <div className="input-field">
                            <Text field="productTitle" type="text" onChange={this.productTitleChange.bind(this)}/>
                            <label htmlFor="improductTitleage">Product Title</label>
                          </div>
                          <div className="input-field">
                            <Text field="productImage" type="url" onChange={this.productImageChange.bind(this)}/>
                            <label htmlFor="productImage">Product Image Url</label>
                            {
                              (this.state.productImageValid !== null && !this.state.productImageValid) && <p className="error">
                                  <span>Not A Valid Image</span>
                                </p>
                            }
                          </div>
                        </div>
                  }
                </div>
                <div className="input-field col s12 rows-input">

                  {
                    this.state.rows.length <= 0
                      ? <a className={"link deep-purple-text lighten-1"} onClick={this.newRow}>Add Metrics Table</a>
                      : <h4 className="more-holder">
                          <span>Metrics Table</span>
                          <a className={"more"} onClick={this.newRow}>
                            <img alt={"img"} src={"/plus.png"}/>
                          </a>
                        </h4>
                  }
                  {
                    _.map(this.state.rows, (a, i) => {
                      return <div key={i} className="metrics-row-container">
                        <div className="metrics-row">
                          <div className="more-holder metric">
                            <input className="metric-row" type="text" onChange={this.rowChange.bind(this, i)} placeholder="Row Title"/> {
                              (a.columns.length < 3) && <a className={"link deep-purple-text lighten-1"} onClick={this.newCol.bind(this, i)}>
                                  Add Metric
                                </a>
                            }
                            <div className="metric-col-master-holder">
                              {
                                _.map(a.columns, (col, col_i) => {
                                  return <div key={col_i} className="metric-col-holder">
                                    <input className="metric-col small" type="text" onChange={this.colTitleChange.bind(this, i, col_i)} placeholder="Metric Title"/>
                                    <div className="metric-col value">
                                      <input className="small" type="text" onChange={this.colValueChange.bind(this, i, col_i)} placeholder="Metric Value"/>
                                      <div className="color_picker">
                                        {
                                          _.map(this.valueColors, (hex) => {
                                            return <span key={hex} onClick={this.colValueColorChange.bind(this, i, col_i, hex)} className={"box" + (
                                                col.valueColor === hex
                                                ? " active"
                                                : "")} style={{
                                                background: hex
                                              }}></span>
                                          })
                                        }
                                      </div>
                                    </div>
                                  </div>
                                })
                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    })
                  }
                </div>
              </div>
              <button type="submit" disabled={!this.state.enableSubmit} className={"deep-purple lighten-1 btn" + (
                  this.state.loading
                  ? " loading"
                  : "")}>
                <span className="inline">Submit</span>
                {this.state.loading && <img alt={"img"} className="spin inline" src="/loading.png"/>}
              </button>
            </form>)}/>
          <div className="col m6 push-m2 s12 m5">
            <div className="iphone">
              <div className="iphone-top">
                <span className="camera"></span>
                <span className="sensor"></span>
                <span className="speaker"></span>
              </div>
              <div className="top-bar"></div>
              <div className="iphone-screen">
                <img alt={"img"} className="full-width" src={"/topBar.png"}/>
                <div className={"HIT-card"}>
                  <div className={"content"}>
                    {
                      this.state.main_image_url && <div className={"main-image"} style={{
                            backgroundImage: `url(${this.state.main_image_url})`
                          }}/>
                    }
                    {
                      (this.state.productImage || this.state.productTitle) && <div className={"product-preview"}>
                          <div className={"img-holder"}>
                            <img alt={"img"} className={"image"} src={this.state.productImage}/>
                          </div>
                          <div className={"title"}>{this.state.productTitle}</div>
                        </div>
                    }
                    <div className="text-content">
                      <p className={"main-title"}>{
                          this.state.title
                            ? this.state.title
                            : "Title"
                        }</p>
                      <p className={"sub-title"}>{this.state.subtitle}</p>
                    </div>
                  </div>
                  <div className={"metrics"}>
                    {
                      _.map(this.state.rows, (a, a_i) => {
                        return <div key={a_i} className="master-metric-holder">
                          <p className="met-main-title">{a.title}</p>
                          <div className="met-row">
                            {
                              _.map(a.columns, (column, column_i) => {
                                return <div key={column_i} className="met-col">
                                  <span className="met-title">{column.name}</span>
                                  <span className="met-number" style={{
                                      color: column.valueColor
                                    }}>{column.value}</span>
                                </div>
                              })

                            }
                          </div>
                        </div>
                      })
                    }
                  </div>
                  <div className={"actions"}>
                    {
                      _.map(this.state.actions, (a, a_I) => {
                        return <a key={a_I} style={{
                            color: a.color
                          }}>{a.text}</a>
                      })
                    }

                  </div>
                </div>
              </div>
              <div className="buttons">
                <span className="on-off"></span>
                <span className="sleep"></span>
                <span className="up"></span>
                <span className="down"></span>
              </div>
              <div className="bottom-bar"></div>
              <div className="iphone-bottom">
                <span></span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>);
  }
}

const mapStateToProps = state => ({companies: state.companies.companies, fetchedCompanies: state.companies.fetched})

export default connect(mapStateToProps, {getCompanies})(CreateCard)



// WEBPACK FOOTER //
// ./src/Component/CreateCard.js